// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"827bcd45","824":"d9e1c5dc"}[chunkId] + ".chunk.css";
};